import {
  Authenticator,
  Image,
  Heading,
  useTheme,
  View,
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css'; // eslint-disable-line import/no-unresolved
import { ThemeProvider, CssBaseline } from '@mui/material';
import { I18n, Hub } from 'aws-amplify';
import { Provider } from 'react-redux';
import logo from './assets/diamonddigital-logo.svg';
import MainContainer from './containers/MainContainer';
import { refreshSubscriptionToFCM, subscribeToFCM } from './firebase';
import store from './redux/store';
import theme from './styles/ThemeConfig';
import globalEn from './translations/en/global.json';
import globalEs from './translations/es/global.json';
import './styles/styles.css';

I18n.putVocabularies({ en: globalEn.login, es: globalEs.login });

const components = {
  Header() {
    return (
      <View
        style={{
          position: 'absolute',
          left: '0px',
          top: '0px',
          width: '100%',
          minHeight: '97px',
          backgroundColor: 'black',
          boxShadow:
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Image
          alt="Diamond Digital logo"
          src={logo}
          style={{ maxWidth: '203px' }}
        />
      </View>
    );
  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          {I18n.get('Welcome Back')}
        </Heading>
      );
    },
  },
};

Hub.listen('auth', data => {
  const { payload } = data;
  switch (payload.event) {
    case 'signIn':
      subscribeToFCM();
      break;
    case 'tokenRefresh':
      refreshSubscriptionToFCM();
      break;
    default:
      return;
  }
});

const App = () => {
  return (
    <Authenticator
      variation="modal"
      loginMechanisms={['email']}
      components={components}
      hideSignUp={true}
    >
      {() => (
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <MainContainer />
          </ThemeProvider>
        </Provider>
      )}
    </Authenticator>
  );
};

export default App;
